<script>
import Layout from '@layouts/main';
import DriverForm from '@views/drivers/form';

export default {
  components: {
    Layout,
    DriverForm,
  },
  page() {
    return {
      title: this.$t('titles.create_driver'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.drivers'),
          to: { name: 'drivers.index' },
        },
        {
          text: this.$t('titles.create_driver'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'drivers.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_driver')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <DriverForm @submitted="create" />
    </b-card>
  </Layout>
</template>
